import {MutableRefObject} from "react"
import {I18nIndividual as GedcomIndividual} from "../model/gedcom-individual"
import {I18nFamily as GedcomFamily} from "../model/gedcom-family"


/**
 * Expose context for usage from far away components.
 */
export class CreatorDataContext {
    // For import/export actions
    creatorDataRef: MutableRefObject<{ individuals: GedcomIndividual[], families: GedcomFamily[] }> = { current: { individuals: [], families: [] }}
}